import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AnnualMenu from "./AnnualMenu";
import { NavLink } from "react-router-dom";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { toast, ToastContainer } from "react-toastify";
import config from "../../Config";

function AddClassesInSessions(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [sessionsLoading, setSessionsLoading] = useState(true);
  const [SessionId, setSessioinId] = useState(
    localStorage.getItem("DefaultSession")
  );
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    document.title = "Add Classes In Sessions";
  }, []);

  useEffect(() => {
    const params = {
      AccessKey,
      UserID,
      MemberType: MemberType || "Admin",
      pageNo: 1,
      pageSize: 1000,
      SchoolID: 1,
    };
    axios({
      method: "post",
      url: config.base_url + "AcademicSession/GetAcademicSessions",
      headers: { "Content-Type": "application/json" },
      data: params,
    })
      .then((res) => {
        const list = res.data?.ListofRecords || [];
        setSessions(list);
        setSessionsLoading(false);
      })
      .catch(() => {
        setSessions([]);
        setSessionsLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const targetSession =
    sessions.length > 0
      ? sessions.reduce((max, s) =>
          (s.Session_ID || 0) > (max?.Session_ID || 0) ? s : max
        )
      : null;
  const selectedSession = sessions.find(
    (s) => String(s.Session_ID) === String(SessionId)
  );
  const selectedIsTarget =
    targetSession && SessionId && String(targetSession.Session_ID) === String(SessionId);
  const noTargetSession = !targetSession || sessions.length < 2;

  const handleAddClassesInSession = () => {
    if (!SessionId || SessionId === "0" || SessionId === "") {
      toast.error("Please select a session to copy classes from.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (noTargetSession) {
      toast.error("Create the next academic session first, then try again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (selectedIsTarget) {
      toast.error(
        "Selected session is the latest. Create the next academic session first, then select the previous session to copy from.",
        { position: toast.POSITION.TOP_RIGHT }
      );
      return;
    }
    setLoading(true);
    const apiData = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      SessionID: parseInt(SessionId, 10) || 0,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AnnualTask/AddClassesInSession",
      headers: {
        "Content-Type": "application/json",
      },
      data: apiData,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(response.data.status_message || "Operation failed", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network error. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <>
      <AnnualMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/AnnualTasks/AnnualTasksDashboard">
                        Annual Tasks{" "}
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Classes In Sessions
                    </li>
                  </ol>
                </nav>
                <div className="page-title">
                  Generate Classes And Sections In New Academic Session
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="bg-light p-md-4 rounded-2">
                  <p>
                    This module copies all classes, sections, and fee structure
                    from the selected session into the <b>newest</b> academic session
                    (the one you added in tblacademicsessions). The new session must
                    already exist and must have the highest Session ID.
                  </p>
                  <b>Pre-requirements:</b>
                  <ul className="mb-3">
                    <li>Add the new academic session (e.g. 2025–26) in the system.</li>
                    <li>Select the session to copy from (usually the current/previous session) below.</li>
                  </ul>

                  {sessionsLoading ? (
                    <p className="text-muted"><Spinner animation="border" size="sm" className="me-2" />Loading sessions…</p>
                  ) : (
                    <>
                      <div className="mb-3 p-3 rounded bg-white border">
                        <strong>Next academic session (target):</strong>{" "}
                        {noTargetSession ? (
                          <span className="text-danger">
                            Not available — create the next academic session first (e.g. new year in Setup/Academic Sessions).
                          </span>
                        ) : (
                          <span className="text-success">
                            {targetSession.Session_Name || targetSession.Session_ID}
                          </span>
                        )}
                      </div>

                      {selectedSession && targetSession && !selectedIsTarget && (
                        <p className="text-muted mb-3">
                          Classes and sections will be copied from <strong>{selectedSession.Session_Name}</strong> into <strong>{targetSession.Session_Name}</strong>.
                        </p>
                      )}

                      {selectedIsTarget && (
                        <div className="alert alert-warning mb-3">
                          The selected session is the latest. Create the next academic session first, then come back and select the previous session to copy from.
                        </div>
                      )}
                    </>
                  )}

                  <div className="row align-items-end">
                    <div className="col-md-4">
                      <label className="form-label">Copy classes from session</label>
                      <select
                        className="form-select"
                        value={SessionId || ""}
                        onChange={(e) => setSessioinId(e.target.value)}
                        disabled={sessionsLoading}
                      >
                        <option value="">Please Select</option>
                        {sessions.map((s) => (
                          <option key={s.Session_ID} value={s.Session_ID}>
                            {s.Session_Name || s.Session_ID}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      {loading ? (
                        <Spinner animation="border" role="status" />
                      ) : (
                        <button
                          type="button"
                          onClick={handleAddClassesInSession}
                          className="button button-primary"
                          disabled={sessionsLoading || noTargetSession || selectedIsTarget || !SessionId}
                        >
                          Generate Classes &amp; Sections
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddClassesInSessions;
